import Form from 'antd/lib/form';

export const useAppFormInstance = Form.useFormInstance;
